// VendorPendingOrdersScreen.jsx

import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Alert,
  Badge,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { useGetVendorPendingOrdersQuery } from "../slices/orderApiSlice";

const VendorPendingOrdersScreen = () => {
  const navigate = useNavigate();

  const {
    data: pendingOrders = [],
    isLoading,
    isError,
    error,
  } = useGetVendorPendingOrdersQuery();

  const handleViewDetails = (orderId) => {
    navigate(`/vendor/orders/${orderId}`);
  };

  if (isLoading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ height: "80vh" }}
      >
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  if (isError) {
    return (
      <Container className="mt-4">
        <Alert variant="danger">
          {error?.data?.message || "Failed to load pending orders"}
        </Alert>
      </Container>
    );
  }

  if (!pendingOrders.length) {
    return (
      <Container className="mt-4 text-center">
        <h5>No pending orders found.</h5>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <h2 className="text-center mb-4">Pending Orders</h2>

      {pendingOrders.map((order) => (
        <Card className="mb-4 shadow-sm" key={order._id}>
          <Card.Body>
            <Row>
              {/* 🔹 Customer Info */}
              <Col md={6}>
                <h5>
                  Customer: {order.customerId?.name || "N/A"}{" "}
                  <small className="text-muted">
                    ({order.customerId?.email || "N/A"})
                  </small>
                </h5>

                <p className="mb-1">
                  Status:{" "}
                  <Badge bg={order.status === "Delivered" ? "success" : "warning"}>
                    {order.status}
                  </Badge>
                </p>

                <p className="mb-0">
                  Total Amount:{" "}
                  <strong>
                    ₹ {order.totalAmount.toFixed(2)}
                    {/* {order.status === "Delivered"
                      ? order.totalAmount.toFixed(2)
                      : "Pending"} */}
                  </strong>
                </p>
              </Col>

              {/* 🔹 Shipping Address */}
              <Col md={6}>
                <h6>Shipping Address</h6>
                <p className="mb-1">
                  {order.shippingAddress?.address},{" "}
                  {order.shippingAddress?.area}
                </p>
                <p className="mb-1">
                  {order.shippingAddress?.city} -{" "}
                  {order.shippingAddress?.pincode}
                </p>
                <p className="mb-0">
                  Phone: {order.shippingAddress?.phoneNumber}
                </p>
              </Col>
            </Row>

            {/* 🔹 Products */}
            <h6 className="mt-3">Products</h6>
            {order.products.map((product, index) => (
              <div
                key={product.productId?._id || index}
                className="ms-3"
              >
                <p className="mb-1">
                  <strong>{product.productId?.name || "Product"}</strong> — Qty:{" "}
                  {product.quantity} — Unit Price: ₹
                  {product.unitPrice.toFixed(2)}
                </p>
              </div>
            ))}

            {/* 🔹 Action */}
            <div className="text-end mt-3">
              <Button
                variant="primary"
                onClick={() => handleViewDetails(order._id)}
              >
                <FaEye className="me-2" />
                View Details
              </Button>
            </div>
          </Card.Body>
        </Card>
      ))}
    </Container>
  );
};

export default VendorPendingOrdersScreen;
